import axios from 'axios'
import { decamelizeKeys, camelizeKeys } from 'humps'

import type { FetchParams, RawAffiliate } from './types'
import parse from './parse'

const AFFILIATES_API = process.env.AFFILIATES_API

const request = axios.create({
  baseURL: AFFILIATES_API,
})

export async function fetchAffiliates(params: FetchParams) {
  const response = await request
    .get('affiliates', { params: decamelizeKeys(params) })
    .then(
      (response) => (camelizeKeys(response.data) as unknown) as RawAffiliate[],
    )

  return response.map(parse)
}
